export default "__VITE_ASSET__CEwnIU3h__"